// extracted by mini-css-extract-plugin
export default {"cbody":"checkout_cbody__4k3J9","box":"checkout_box__IlEi1","cimg":"checkout_cimg__8wLC1"};